
import axios from 'axios'
import { defineComponent } from 'vue'
import { mapState } from 'vuex'

export default defineComponent({
  name: 'AddCustomGroupDialog',
  props: ['open', 'close', 'field'],
  computed: {
    ...mapState('authModule', ['user']),
    showDialog(): boolean {
      return this.open
    },
  },
  data: function() {
    return {
      name: null,
      errors: {},
    }
  },
  methods: {
    addGroup() {
      axios
        .post('/api/groups/' + this.field, {
          name: this.name,
        })
        .then(() => {
          this.onClose()
        })
        .catch(error => {
          this.errors = error.response.data.errors
        })
    },
    onClose() {
      this.name = null
      this.errors = {}
      this.$emit('close')
    },
  },
})
